import "core-js/modules/es.array.push.js";
import { ref, shallowRef } from '@vue/reactivity';
import AMapLoader from '@amap/amap-jsapi-loader';
import Config from '@/config';
import GeocoderUtil from '@/utils/GeocoderUtil';
import AssetsUtil from '@/utils/AssetsUtil';
import CommonUtil from '../../../../utils/CommonUtil';
import { showConfirmDialog, showDialog, showToast } from 'vant';
import RouterUtil from '@/utils/RouterUtil';
import StorageUtil from '@/utils/StorageUtil';
import OrderApi from '@/api/order-api';
import VehicleApi from '@/api/vehicle-api';
export default {
  name: 'order-progress',
  computed: {
    Config() {
      return Config;
    },
    CommonUtil() {
      return CommonUtil;
    }
  },
  setup() {
    const noQueryAddress = ref(false);
    const map = shallowRef();
    const geolocation = shallowRef();
    const geocoder = shallowRef();
    const weather = shallowRef();
    const driving = shallowRef();
    const vehicleTypes = shallowRef();
    const vehiclePrices = shallowRef();
    const vehicleTypeCheckedCount = shallowRef(0);
    const vehicleTypeUnCheckedCount = shallowRef(0);
    const position = shallowRef(Config.defaultPosition);
    const cityName = shallowRef('');
    const cityCode = shallowRef('');
    const lastCityCode = shallowRef('');
    const showWeather = shallowRef(false);
    const cityWeather = shallowRef('');
    const cityWeatherIcon = shallowRef(require('@/assets/icon/weather/default.svg'));
    const startAddress = shallowRef('');
    const startPosition = shallowRef([]);
    const endAddress = shallowRef('您要去哪里？');
    const endPosition = shallowRef([]);
    const kilometer = shallowRef('--');
    const drivingTime = shallowRef('--');
    const reserveDay = shallowRef(0);
    const reserveTime = shallowRef(['12', '00']);
    const refreshStatusInterval = ref();
    const awaitSecondInterval = ref();
    const orderData = ref();
    const orderDetailData = ref();
    const driverPosition = ref();
    const awaitSecond = ref(0);
    const startPointMarker = shallowRef();
    const endPointMarker = shallowRef();
    const driverMarker = shallowRef();
    const driverStatusInfoWindow = shallowRef();
    return {
      noQueryAddress,
      map,
      geolocation,
      geocoder,
      vehicleTypes,
      vehiclePrices,
      vehicleTypeCheckedCount,
      vehicleTypeUnCheckedCount,
      weather,
      driving,
      position,
      cityName,
      cityCode,
      lastCityCode,
      showWeather,
      cityWeather,
      cityWeatherIcon,
      startAddress,
      startPosition,
      endAddress,
      endPosition,
      kilometer,
      drivingTime,
      reserveDay,
      reserveTime,
      refreshStatusInterval,
      awaitSecondInterval,
      orderData,
      orderDetailData,
      driverPosition,
      awaitSecond,
      startPointMarker,
      endPointMarker,
      driverMarker,
      driverStatusInfoWindow
    };
  },
  mounted() {
    const that = this;
    this.orderData = StorageUtil.getObject('orderData');
    that.getUndoneOrderDetail();
    setTimeout(function () {
      //DOM初始化完成进行地图初始化
      that.initMap();
      that.refreshStatusInterval = setInterval(function () {
        that.getUndoneOrderDetail();
      }, 5 * 1000);
    }, 250);
    this.vehicleTypes = [{
      icon: require('@/assets/icon/vehicle/taxi.png'),
      name: '出租车',
      description: '传统出租 接单快速',
      pricePrefix: '预估',
      discount: 1.0,
      checked: true
    }, {
      icon: require('@/assets/icon/vehicle/taxi-new.png'),
      name: '新出租',
      description: '网约价格 超值畅行',
      pricePrefix: '预估',
      discount: 0.9,
      checked: true
    }];
    this.calculateVehicleTypeCheck();
    this.vehiclePrices = [];
    try {
      const orderInitiateData = StorageUtil.getObject('orderInitiateData');
      if (orderInitiateData) {
        this.startAddress = orderInitiateData.startAddress;
        this.startPosition = orderInitiateData.startPosition;
        this.endAddress = orderInitiateData.endAddress;
        this.endPosition = orderInitiateData.endPosition;
      }
    } catch (e) {} finally {
      // StorageUtil.remove("orderInitiateData");
    }
  },
  unmounted() {
    clearInterval(this.awaitSecondInterval);
    clearInterval(this.refreshStatusInterval);
    if (this.map) {
      this.map.destroy();
    }
  },
  methods: {
    RouterUtil() {
      return RouterUtil;
    },
    initMap() {
      const that = this;
      window._AMapSecurityConfig = {
        securityJsCode: '23ca323d154479c363c8c8df0b1ddb92'
      };
      AMapLoader.load({
        key: Config.mapKey,
        // 申请好的Web端开发者Key，首次调用 load 时必填
        version: Config.mapVersion,
        // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
        // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        'AMap.Geocoder', 'AMap.Geolocation', 'AMap.Weather', 'AMap.Driving']
      }).then(AMap => {
        this.map = new AMap.Map('map', {
          //设置地图容器ID
          viewMode: '2D',
          //是否为3D地图模式
          zoom: 16,
          //初始化地图级别
          center: this.position //初始化地图中心点位置
          // mapStyle: "amap://styles/macaron",   //地图样式
          // dragEnable: false,
        });
        this.geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          //是否使用高精度定位，默认:true
          timeout: 10000,
          //超过10秒后停止定位，默认：5s
          //position: 'RB',                         //定位按钮的停靠位置
          //offset: [10, 20],                       //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
          zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
        });
        this.geocoder = new AMap.Geocoder({
          // city: "010",                            //城市设为北京，默认：“全国”
          // radius: 1000                            //范围，默认：500
        });
        this.weather = new AMap.Weather();
        this.driving = new AMap.Driving({
          map: this.map,
          //驾车策略，包括 LEAST_TIME，LEAST_FEE, LEAST_DISTANCE,REAL_TRAFFIC
          // policy: AMap.DrivingPolicy.LEAST_TIME,
          autoFitView: false,
          // panel: "panel"
          hideMarkers: true
        });
        this.map.on('moveend', function () {
          that.position = that.map.getCenter();
          if (!that.noQueryAddress) {
            that.getAddress(that.position);
          }
          that.noQueryAddress = false;
        });
        this.getUndoneOrderDetail();
        this.getAddress(this.position);
        this.getCurrentPosition();
      }).catch(e => {
        console.error(e);
      });
    },
    getCurrentPosition() {
      const that = this;
      try {
        this.geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete') {
            that.position = result.position;
          } else {
            that.position = Config.defaultPosition;
          }
          // that.map.setCenter(that.position);
          that.getAddress(that.position);
        });
      } catch (e) {
        that.position = Config.defaultPosition;
        // that.map.setCenter(that.position);
        that.getAddress(that.position);
      }
    },
    getAddress(position) {
      const that = this;
      this.geocoder.getAddress(position, function (status, result) {
        if (status === 'complete' && result.regeocode) {
          const addressComponent = result.regeocode.addressComponent;
          const formattedAddress = result.regeocode.formattedAddress;
          const showAddress = formattedAddress.replace(addressComponent.province, '').replace(addressComponent.city, '').replace(addressComponent.district, '').replace(addressComponent.township, '');
          // console.error(showAddress);
          that.cityCode = addressComponent.adcode;
          that.cityName = addressComponent.district.length > 0 && (addressComponent.district.indexOf('市') > 0 || addressComponent.district.indexOf('县') > 0) ? addressComponent.district : addressComponent.city;
          if (that.cityCode !== that.lastCityCode) {
            that.getWeather(that.cityCode);
          }
          that.lastCityCode = that.cityCode;
          if (that.cityName.length < 1) {
            that.cityName = '未知地区';
          }
        } else {
          that.cityName = '未知地区';
          console.error('根据经纬度查询地址失败：' + status);
        }
      });
    },
    getWeather(cityCode) {
      const that = this;
      that.weather.getLive(cityCode, function (err, data) {
        if (!err) {
          if (data.weather && data.temperature) {
            that.showWeather = true;
            that.cityWeather = data.temperature + '℃';
            that.cityWeatherIcon = AssetsUtil.getWeatherIcon(data.weather);
          } else {
            that.showWeather = false;
          }
        } else {
          that.showWeather = false;
        }
      });
    },
    getDriving(startPosition, endPosition) {
      const that = this;
      this.driving.search(startPosition, endPosition, function (status, result) {
        // result 即是对应的驾车导航信息，相关数据结构文档请参考：https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
        if (status === 'complete') {
          if (result.routes) {
            const routes = result.routes;
            if (routes.length > 0) {
              const route = routes[0];
              const distance = parseFloat(route.distance);
              const tolls = parseFloat(route.tolls);
              that.kilometer = parseFloat(distance / 1000.00);
              that.drivingTime = route.time;
              let amount = 7.00;
              let valuationMileage = that.kilometer - 1.5;
              let additionalMileage = valuationMileage - 2.1;
              if (valuationMileage > 0) {
                if (valuationMileage > 2.1) {
                  amount += 2.1 * 2.0;
                  amount += additionalMileage * (2.00 * 1.4);
                } else {
                  amount += valuationMileage * 2.0;
                }
              }
              for (let i = 0; i < that.vehicleTypes.length; i++) {
                that.vehiclePrices[i] = (amount * that.vehicleTypes[i].discount + tolls).toFixed(2);
              }
              that.$forceUpdate();
            }
          }
        } else {
          console.error('获取驾车数据失败：' + result);
        }
      });
    },
    checkVehicleType(index) {
      this.vehicleTypes[index].checked = !this.vehicleTypes[index].checked;
      this.calculateVehicleTypeCheck();
      this.$forceUpdate();
    },
    goAddress(type) {
      StorageUtil.setObject('positionData', {
        type: type,
        position: this.position
      });
      this.$router.push('/address');
    },
    goBack() {
      StorageUtil.setObject('addressData', {
        type: 'end',
        address: '',
        position: ''
      });
      RouterUtil.back();
    },
    calculateVehicleTypeCheck() {
      if (this.vehicleTypes && this.vehicleTypes.length) {
        this.vehicleTypeCheckedCount = 0;
        this.vehicleTypeUnCheckedCount = 0;
        for (let i = 0; i < this.vehicleTypes.length; i++) {
          const vehicleType = this.vehicleTypes[i];
          if (vehicleType.checked) {
            this.vehicleTypeCheckedCount++;
          } else {
            this.vehicleTypeUnCheckedCount++;
          }
        }
      }
    },
    getUndoneOrderDetail() {
      var _that$orderData;
      const that = this;
      if ((_that$orderData = that.orderData) !== null && _that$orderData !== void 0 && _that$orderData.order_number) {
        OrderApi.getOrderDetail(that.orderData.order_number).then(function (result) {
          var _result$response;
          if ((_result$response = result.response) !== null && _result$response !== void 0 && (_result$response = _result$response.data) !== null && _result$response !== void 0 && _result$response.data) {
            that.orderDetailData = result.response.data.data;
            if (that.orderDetailData) {
              if (that.orderDetailData.order_state === 'ORDER_STATUS_CANCEL_BY_DRIVER') {
                showDialog({
                  message: '当前订单已被司机取消，请重新叫车'
                }).then(() => {
                  RouterUtil.home();
                });
              }
              if (that.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT') {
                // that.goCheckout()
              } else if (that.orderDetailData.order_state === 'ORDER_STATUS_RATING') {
                // that.$router.replace('/center');
              } else {
                that.orderDetailData.arriveBeginAddressTimeDate = CommonUtil.toDate(that.orderDetailData.arrive_pick_up_time, 'YYYY-MM-DD HH:mm:ss');
                if (that.awaitSecond === 0 || isNaN(that.awaitSecond)) {
                  that.awaitSecond = (new Date().getTime() - that.orderDetailData.arriveBeginAddressTimeDate.getTime()) / 1000;
                }
                if (!that.awaitSecondInterval) {
                  that.awaitSecondInterval = setInterval(function () {
                    that.awaitSecond++;
                  }, 1000);
                }
                try {
                  if (that.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_PICK_UP') {
                    if (that.driving) {
                      that.driving.clear();
                    }
                  }
                  if (that.map) {
                    // that.map.clearMap();
                  }
                  if (that.orderDetailData && (that.orderDetailData.order_state === 'ORDER_STATUS_CONFIRMING' || that.orderDetailData.order_state === 'ORDER_STATUS_WAITING' || that.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF')) {
                    const startPointIcon = new AMap.Icon({
                      image: require('@/assets/icon/map/start-point.png'),
                      size: [32, 32],
                      imageSize: [32, 32]
                    });
                    if (that.startPointMarker) {
                      that.startPointMarker.remove();
                    }
                    that.startPointMarker = new AMap.Marker({
                      position: that.startPosition,
                      icon: startPointIcon,
                      offset: new AMap.Pixel(-13, -30)
                    });
                    that.map.add(that.startPointMarker);
                  }
                } catch (e) {}
                if (that.orderDetailData.order_state !== 'ORDER_STATUS_PROGRESSING') {
                  if (that.driverStatusInfoWindow) {
                    that.driverStatusInfoWindow.close();
                  }
                }
                if (that.orderDetailData.order_type === 'ORDER_TYPE_RESERVATION' && that.orderDetailData.order_state === 'ORDER_STATUS_CONFIRMING' || that.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF' || that.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT') {
                  if (that.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF' || that.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT') {
                    try {
                      const endPointIcon = new AMap.Icon({
                        image: require('@/assets/icon/map/end-point.png'),
                        size: [32, 32],
                        imageSize: [32, 32]
                      });
                      if (that.endPointMarker) {
                        that.endPointMarker.remove();
                      }
                      that.endPointMarker = new AMap.Marker({
                        position: that.endPosition,
                        icon: endPointIcon,
                        offset: new AMap.Pixel(-13, -30)
                      });
                      that.map.add(that.endPointMarker);
                      that.getDriving(that.startPosition, that.endPosition);
                      that.map.setFitView(null, false, [120, 64, 120, 64]);
                    } catch (e) {}
                  }
                  return;
                }
                that.getDriverPosition();
              }
            } else {
              alert(1);
              // that.$router.replace('/center');
            }
          }
        }).catch(function (error) {
          console.log(error);
          showToast({
            message: '订单状态请求失败'
          });
        });
      } else {
        RouterUtil.home();
      }
    },
    getDriverPosition() {
      const that = this;
      VehicleApi.getProgressVehicle(that.orderData.order_number).then(function (result) {
        if (result.vehicle) {
          that.driverPosition = result.vehicle;
          //that.driverPosition.position = GeocoderUtil.BD09_GCJ02(that.driverPosition.longitude, that.driverPosition.latitude);
          that.driverPosition.position = [that.driverPosition.longitude, that.driverPosition.latitude];
          if (that.orderDetailData && that.orderDetailData.order_state === 'ORDER_STATUS_WAITING') {
            that.getDriving(that.driverPosition.position, that.startPosition);
          }
          if (that.orderDetailData && that.orderDetailData.order_state === 'ORDER_STATUS_PROGRESSING') {
            if (that.awaitSecondInterval) {
              clearInterval(that.awaitSecondInterval);
            }
            if (that.orderDetailData.order_type !== 'ORDER_TYPE_VOICE') {
              that.getDriving(that.driverPosition.position, that.endPosition);
            }
            if (that.orderDetailData.order_type !== 'ORDER_TYPE_VOICE') {
              const endPointIcon = new AMap.Icon({
                image: require('@/assets/icon/map/end-point.png'),
                size: [32, 32],
                imageSize: [32, 32]
              });
              if (that.endPointMarker) {
                that.endPointMarker.remove();
              }
              that.endPointMarker = new AMap.Marker({
                position: that.endPosition,
                icon: endPointIcon,
                offset: new AMap.Pixel(-13, -30)
              });
              that.map.add(that.endPointMarker);
            }
          }
          const driverIcon = new AMap.Icon({
            image: require('@/assets/icon/map/taxi-top-view.png'),
            size: [32, 32],
            imageSize: [32, 32]
          });
          if (that.driverMarker) {
            that.driverMarker.remove();
          }
          that.driverMarker = new AMap.Marker({
            position: that.driverPosition.position,
            icon: driverIcon,
            offset: new AMap.Pixel(-13, -30)
          });
          that.map.add(that.driverMarker);
          if (that.orderDetailData && that.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_PICK_UP') {
            const info = [];
            info.push('<div class=\'input-card content-window-card\' ' + 'style=\'font-size: 12px; color: #555; padding-left: 8px;\'>' + '司机已经到达' + '</div>');
            that.driverStatusInfoWindow = new AMap.InfoWindow({
              content: info.join(''),
              //使用默认信息窗体框样式，显示信息内容
              offset: [2, -36]
            });
            that.driverStatusInfoWindow.open(that.map, that.driverPosition.position);
            that.map.setCenter(that.driverPosition.position);
          }
          that.map.setFitView(null, false, [120, 64, 120, 64]);
        }
      });
    },
    contactDriver() {
      // if (this.orderDetailData && this.orderDetailData.driver_phone_number) {
      //   window.location.href = 'tel:' + this.orderDetailData.driver_phone_number;
      // } else {
      //   showToast('暂时无法联系司机');
      // }
      OrderApi.privacyCall(this.orderData.order_number).then(function (result) {
        if (result.response.data.code === 200) {
          window.location.href = 'tel:' + result.response.data.data;
        } else {
          showToast('暂时无法联系司机');
        }
      }).catch(function () {
        showToast('暂时无法联系司机');
      });
    },
    cancelOrder() {
      const that = this;
      showConfirmDialog({
        message: '确定要取消订单吗？',
        confirmButtonText: '取消订单'
      }).then(() => {
        OrderApi.cancelOrder(that.orderData.order_number, '').then(function (result) {
          if (result.response.data.code === 200) {
            StorageUtil.setObject('addressData', {
              type: 'end',
              address: '',
              position: ''
            });
            RouterUtil.back(true);
          }
          if (result.response.data.code === 201000000) {
            showDialog({
              message: '当前状态已经无法取消订单'
            });
          }
        });
      }).catch(() => {
        // on cancel
      });
    },
    goCheckout() {
      StorageUtil.setObject('checkoutData', {
        orderId: this.orderDetailData.order_id
      });
      RouterUtil.go('/order/checkout');
    }
  }
};